module.exports = __webpack_public_path__ + "static/gal_icon-e2c69d87fffcdae8c4d2.png";